var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-center col-4"},[_c('OverlayLoader',{ref:"overlayLoader"}),_c('button',{staticClass:"btn btn-primary btn-block",attrs:{"type":"button"},on:{"click":_vm.clickSaveButton}},[_vm._v(" 回答 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }